import { useShallow } from 'zustand/react/shallow'

import { useAppState } from './app.state'
import type { UISlice } from './ui/state'

export interface AppState extends UISlice {}

export const useSidebarExpanded = () =>
  useAppState(useShallow(state => [state.sidebarExpanded, state.setSidebarExpanded, state.toggleSidebar] as const))

export { useAppState }
